import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios' // se usar axios

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: (typeof window !== 'undefined' && window.Laravel && window.Laravel.user) ? window.Laravel.user : null
  },
  getters: {
    user: state => state.user,
    roles: state => (state.user && Array.isArray(state.user.tipo_user)) ? state.user.tipo_user : []
  },
  mutations: {
    setUser(state, user) {
      state.user = user
    },
    clearUser(state) {
      state.user = null
    }
  },
  actions: {
    async fetchUser({ commit }) {
      try {
        const { data } = await axios.get('/api/user')
        commit('setUser', data.user)
        return data.user
      } catch (e) {
        commit('clearUser')
        return null
      }
    }
  }
})
